<template>
  <TemplateDataGrid ref="grid"
                    gridId="PeStudentChangeQueryRollClass"></TemplateDataGrid>
</template>

<script>
import TemplateDataGrid from '../../../../../../../templates/TemplateDataGrid'
export default {
  name: 'StatusChangeQueryRollClass',
  components: {
    TemplateDataGrid
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    reloadGridData () {
      if (this.active) {
        let grid = this.$refs.grid
        if (grid) {
          grid.loadGridData()
        }
      }
    }
  },
  watch: {
    active: function () {
      this.reloadGridData()
    }
  }
}
</script>
